export const TermsSection3 = () => {
  return (
    <>
      <section id="intellectual-property">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Intellectual Property</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            6.1 Our Intellectual Property
          </h3>
          <p>
            The Service, including all content, features, functionality, software, code, design,
            graphics, logos, and trademarks, is owned by WinGrow and is protected by international
            copyright, trademark, patent, and other intellectual property laws.
          </p>
          <p>
            You may not copy, modify, distribute, sell, or lease any part of our Service without our
            express written permission.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.2 Your Content</h3>
          <p>
            You retain all rights to the content you create, upload, or share through the Service
            (&quot;Your Content&quot;). By using the Service, you grant us a limited, worldwide,
            non-exclusive, royalty-free license to use, store, and process Your Content solely to
            provide and improve the Service.
          </p>
          <p>
            You represent and warrant that you own or have the necessary rights to Your Content and
            that it does not violate any third-party rights or applicable laws.
          </p>
        </div>
      </section>

      <section id="third-party-services">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Third-Party Services</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>Our Service integrates with third-party platforms and services, including:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Facebook, Instagram, and WhatsApp (Meta Platforms)</li>
            <li>Analytics and monitoring services</li>
            <li>Payment processors (if applicable)</li>
            <li>AI and machine learning providers</li>
          </ul>
          <p>
            These third-party services are governed by their own terms of service and privacy
            policies. We are not responsible for the content, accuracy, or practices of these
            third-party services.
          </p>
          <p>
            Your use of third-party services through our platform is at your own risk, and you
            should review their terms and policies before using them.
          </p>
        </div>
      </section>

      <section id="payment-terms">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Payment Terms</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">8.1 Subscription Fees</h3>
          <p>
            Our Service is offered on a subscription basis. By subscribing, you agree to pay the
            applicable fees as described on our pricing page or in your subscription agreement.
          </p>
          <p>
            Subscription fees are billed in advance on a monthly or annual basis and are
            non-refundable except as required by law or as expressly stated in these Terms.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">8.2 Payment Processing</h3>
          <p>
            Payments are processed through third-party payment processors. By providing payment
            information, you authorize us to charge your chosen payment method for all fees
            incurred.
          </p>
          <p>
            You are responsible for maintaining valid payment information and for all charges
            incurred under your account.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            8.3 Cancellation and Refunds
          </h3>
          <p>
            You may cancel your subscription at any time through your account settings. Upon
            cancellation, you will continue to have access to the Service until the end of your
            current billing period.
          </p>
          <p>
            Refunds are not provided for partial months or years, except as required by law or at
            our sole discretion.
          </p>
        </div>
      </section>

      <section id="termination">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Termination</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">9.1 Termination by You</h3>
          <p>
            You may terminate your account at any time by contacting us at{' '}
            <a
              href="mailto:viprielt24@gmail.com"
              className="text-blue-600 underline hover:text-blue-800"
            >
              viprielt24@gmail.com
            </a>{' '}
            or through your account settings.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">9.2 Termination by Us</h3>
          <p>
            We may suspend or terminate your account and access to the Service at any time, without
            prior notice, if we determine that you have:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Violated these Terms or any applicable laws</li>
            <li>Engaged in fraudulent or illegal activity</li>
            <li>Failed to pay applicable fees</li>
            <li>Created risk or legal exposure for us or other users</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            9.3 Effect of Termination
          </h3>
          <p>Upon termination:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Your access to the Service will be immediately revoked</li>
            <li>
              We may delete your account data, subject to our data retention policies and legal
              obligations
            </li>
            <li>You will remain liable for all fees incurred prior to termination</li>
            <li>
              Sections of these Terms that by their nature should survive termination will continue
              to apply
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};
